/** @format */

import axiosInstance from "../../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const genrateEsignTokenWithDocumentID = createAsyncThunk(
  "genrateEsignTokenWithDocumentID/genrateEsignTokenWithDocumentID",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/MultieSign/RequestMutiSign`,
        data?.api_payload,
        {
          headers: {
            signature: data.api_header.signature,
          },
        }
      );
      // console.log(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
  {
    serializeError: true,
    serializableCheck: {
      ignoredPaths: ["payload.headers"],
    },
  }
);

const genrateEsignTokenWithDocumentIDSlice = createSlice({
  name: "genrateEsignTokenWithDocumentID",
  initialState: {
    documentData: "",
    documentStatus: "idle",
    error: null,
    showLoder: false,
  },
  reducers: {
    setShowLoder(state, action) {
      const { payload } = action;
      state.showLoder = payload;
    },
    clearDocumentData(state) {
      state.documentData = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(genrateEsignTokenWithDocumentID.pending, (state, action) => {
        state.documentStatus = STATUSES.LOADING;
      })
      .addCase(genrateEsignTokenWithDocumentID.fulfilled, (state, action) => {
        state.documentData = action.payload;
        state.documentStatus = STATUSES.IDLE;
      })
      .addCase(genrateEsignTokenWithDocumentID.rejected, (state, action) => {
        state.documentStatus = STATUSES.ERROR;
      });
  },
});

export default genrateEsignTokenWithDocumentIDSlice.reducer;
export const { clearDocumentData } =
  genrateEsignTokenWithDocumentIDSlice.actions;
